import type { SessionStepModule } from '../types';
import { LivenessDetail } from './LivenessDetail';
import { LivenessStepRunner } from './LivenessStepRunner';
import { isLivenessStep } from './liveness.utils';

// Liveness step module (SEBI spec §7 — 3D Activation / Flashing / Passive).
export const livenessStepModule: SessionStepModule = {
  key: 'liveness',
  matches: isLivenessStep,
  Runner: LivenessStepRunner,
  Detail: LivenessDetail,
};
